import React from 'react'
import './loadder.css';
export const Loader = () => {
  return (
    <div id="loader" >
    <div id="d1" ></div>
    <div id="d2" ></div>
    <div id="d3" ></div>
    <div id="d4" ></div>
    <div id="d5" ></div>
  </div>
  
  )
}

// import React from 'react'
// import './loadder.css';
// export const Loader = () => {
//   return (
//     <div class="loader" id="loadScreen">
//     <div class="box">
//       <div class="loader6"></div>
//     </div>
//   </div>
//   )
// }
